import { createElement } from 'react';

interface WeaveCheckboxProps extends React.HTMLAttributes<HTMLElement> {
	className?: string;
	disabled?: boolean;
	indeterminate?: boolean;
	checked?: boolean;
	value?: string;
	name?: string;
	showLabel?: boolean;
	label?: string;
	id?: string;
	change: (event: Event) => void;
}

export function WeaveCheckbox({
	className,
	disabled,
	indeterminate,
	checked,
	value,
	name,
	showLabel,
	label,
	id,
	change,
}: WeaveCheckboxProps) {
	return createElement('weave-checkbox', {
		className,
		disabled,
		indeterminate,
		checked,
		value,
		name,
		showLabel,
		label,
		id,
		onChange: change,
	});
}
